import React from "react";
import {Box, Columns, Heading, Form, Table, Button} from "react-bulma-components";

function WorkSection({workItem, onRemove, removedWorkItems, onAdd}){

    return (
        <Box>
            {removedWorkItems.indexOf(workItem.id) !== -1 &&
                <Columns>
                    <Columns.Column>
                        <p style={{color: "red"}}>THIS ITEM WILL BE REMOVED WHEN THE JOB IS CREATED</p>
                    </Columns.Column>
                </Columns>
            }
            <Columns>
                <Columns.Column>
                    <Form.Label>Description</Form.Label>
                    <Form.Input
                        type={"text"}
                        value={workItem.description}
                        disabled={true}
                    />
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Form.Label>Labour Hours</Form.Label>
                    <Form.Input
                        type={"text"}
                        value={workItem.labour_hours}
                        disabled={true}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Labour Cost</Form.Label>
                    <Form.Input
                        type={"text"}
                        value={workItem.labour_cost}
                        disabled={true}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Customer Labour Charge</Form.Label>
                    <Form.Input
                        type={"text"}
                        value={workItem.customer_labour_cost}
                        disabled={true}
                    />
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Table size={"fullwidth"} bordered>
                        <thead>
                            <tr>
                                <th>Part Name</th>
                                <th>Part Supplier</th>
                                <th>Part Number</th>
                                <th>Part Cost</th>
                                <th>Part Customer Charge</th>
                            </tr>
                        </thead>
                        <tbody>
                        {workItem.part_work_lookup.map(part => (
                            <tr>
                                <td>{part.name}</td>
                                <td>{part.supplier ? part.supplier.name : ""}</td>
                                <td>{part.part_number}</td>
                                <td>{part.cost}</td>
                                <td>{part.customer_cost}</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </Columns.Column>
            </Columns>
            <Columns>
                {removedWorkItems.indexOf(workItem.id) === -1 &&
                    <Columns.Column>
                        <Button
                            color="danger"
                            data-testid="remove-work"
                            className="is-pulled-right remove-work"
                            onClick={() => onRemove(workItem)}
                        >
                            Remove Work
                        </Button>
                    </Columns.Column>
                }
                {removedWorkItems.indexOf(workItem.id) !== -1 &&
                    <Columns.Column>
                        <Button
                            color="success"
                            data-testid="remove-work"
                            className="is-pulled-right remove-work"
                            onClick={() => onAdd(workItem)}
                        >
                            Add Work
                        </Button>
                    </Columns.Column>
                }
            </Columns>
        </Box>
    )

}


export default function DefaultWorkItemsSection({workItems, removedWorkItems, addRemovedWorkItem, removeRemovedWorkItem}){
    // addRemovedWorkItem adds a work item to the list of removed ones, that list will then be used on the backend to tell the api which items to ignore
    // removeRemovedWorkItem removes a work item from the list of removed ones


    return (
        <Box>
            <Columns>
                <Columns.Column>
                    <Heading>Default Work Items</Heading>
                </Columns.Column>
            </Columns> {/*.filter(item => removedWorkItems.indexOf(item.id) === -1)*/}
            {workItems.results.map(workItem => (
                <WorkSection
                    workItem={workItem}
                    onRemove={addRemovedWorkItem}
                    removedWorkItems={removedWorkItems}
                    onAdd={removeRemovedWorkItem}
                />
            ))}
        </Box>
    )

}